import React, { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { Button as ThemedButton, buttonTheme } from 'storybook-ui'

import { Button } from 'components/Button'

import { selectSource } from 'root-redux/selects/common'
import { selectUUID } from 'root-redux/selects/user'

import { eventLogger } from 'services/eventLogger.service'

type TWithdrawalButtonProps = {
  subscriptionId: string
  contract: string
  onRequestWithdrawal: (subscriptionId: string, contract: string) => void
  theme?: buttonTheme
  style?: CSSProperties
}

export const WithdrawalButton: React.FC<TWithdrawalButtonProps> = ({
  subscriptionId,
  contract,
  onRequestWithdrawal,
  theme,
  style,
}) => {
  const { t } = useTranslation()
  const source = useSelector(selectSource)
  const userId = useSelector(selectUUID)

  const handleClick = () => {
    eventLogger.logCancelPurchaseButtonTap(source, userId)
    onRequestWithdrawal(subscriptionId, contract)
  }

  const mergedStyle = { margin: '16px auto', ...style }

  return theme ? (
    <ThemedButton theme={theme} onClick={handleClick} style={mergedStyle}>
      {t('subscription.cancelPurchase')}
    </ThemedButton>
  ) : (
    <Button onClick={handleClick} style={mergedStyle}>
      {t('subscription.cancelPurchase')}
    </Button>
  )
}
